import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "downloads--fill-current-color",
  "use": "downloads--fill-current-color-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"downloads--fill-current-color\">\n  <g fill=\"#2274a6\" fill-rule=\"nonzero\">\n    <path d=\"M1.818 13.927l-.062-.05c-.247-.204-.456-.641-.602-1.242a7.914 7.914 0 0 1-.181-1.128A7.335 7.335 0 0 1 .941 11l-.94.018c.001.122.011.326.035.587.04.434.107.869.207 1.28.193.795.487 1.412.935 1.782l.082.066c.765.598 1.547.791 2.143.774h-.002l9.126-.001.033.002c.644.025 1.47-.182 2.274-.829l.011-.01c.463-.375.76-.992.945-1.78a8.311 8.311 0 0 0 .21-1.878v-.008l-.941.012a7.325 7.325 0 0 1-.182 1.633c-.138.588-.345 1.018-.603 1.227l-.009.007c-.607.49-1.226.644-1.67.626H3.377c-.405.01-.986-.133-1.56-.58z\" fill=\"currentColor\" />\n    <path d=\"M7.609 11.266L3.697 7.353a.553.553 0 0 1 .782-.782l2.972 2.972V1.12a.549.549 0 1 1 1.098 0v8.423l2.972-2.972a.553.553 0 0 1 .782.782l-3.912 3.913a.564.564 0 0 1-.782 0z\" fill=\"currentColor\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloads.svg?fill=currentColor
// module id = zb/0
// module chunks = 1